import { HistoricalData } from '@/types/catalyst_search.type'

// 새로운 워크플로우 추가
export const COMPANY_PAGE_OWNERSHIP_WORKFLOWS = ['comp_sheet', 'valuation']
export const COMPANY_PAGE_RECENT_INFO_WORKFLOWS = ['recent_info', 'estimates']
export const COMPANY_PAGE_FINANCIALS_WORKFLOWS = ['financials', 'estimates']

// Overview workflows에 capital_allocation 추가
export const COMPANY_PAGE_OVERVIEW_WORKFLOWS = [
  'overview-1',
  'overview-2',
  'overview-3',
  'overview-4',
  'overview-5',
]

export const COMPANY_PAGE_EARNINGS_HISTORY_WORKFLOWS = [
  'earnings-history',
  'bull-bear',
  'guidance-change',
]

export const COMPANY_PAGE_INDUSTRY_WORKFLOWS = ['industry-competitor']

// ALL_COMPANY_PAGE_WORKFLOWS 업데이트 (중복 제거를 위해 Set 사용)
export const ALL_COMPANY_PAGE_WORKFLOWS = Array.from(
  new Set([
    ...COMPANY_PAGE_OVERVIEW_WORKFLOWS,
    ...COMPANY_PAGE_EARNINGS_HISTORY_WORKFLOWS,
    ...COMPANY_PAGE_INDUSTRY_WORKFLOWS,
    ...COMPANY_PAGE_OWNERSHIP_WORKFLOWS,
    ...COMPANY_PAGE_RECENT_INFO_WORKFLOWS,
    ...COMPANY_PAGE_FINANCIALS_WORKFLOWS,
  ])
)

export const LANGUAGE_OPTIONS = [
  { code: 'en', label: 'English' },
  { code: 'ko', label: '한국어' },
  { code: 'zh-CN', label: '简体中文' },
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'ja', label: '日本語' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'th', label: 'ไทย' },
  { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'ms', label: 'Bahasa Melayu' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'ar', label: 'العربية' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'es', label: 'Español' },
  { code: 'pt', label: 'Português' },
  { code: 'it', label: 'Italiano' },
] as const

export const COMPANY_PAGE_CACHE_TRACKING_KEY = 'company_page_caching'
export interface CompanyPageCachingTrackingItem {
  messageId: string
  conversationId: string
  stockId: string
  stockName: string
  quarter: number
  year: number
  startedAt: string
  sections: string[]
  relatedMessageIds?: string[]
}

// 탭별 워크플로우 매핑
export const TAB_WORKFLOWS_MAP = {
  overview: COMPANY_PAGE_OVERVIEW_WORKFLOWS,
  industry: COMPANY_PAGE_INDUSTRY_WORKFLOWS,
  earnings_history: COMPANY_PAGE_EARNINGS_HISTORY_WORKFLOWS,
  ownership: COMPANY_PAGE_OWNERSHIP_WORKFLOWS,
  recent_info: COMPANY_PAGE_RECENT_INFO_WORKFLOWS,
  financials: COMPANY_PAGE_FINANCIALS_WORKFLOWS,
}

// Currency 관련 타입
export interface FieldCurrencyInfo {
  [stockId: string]: {
    [fieldName: string]: string
  }
}

export interface CurrencyInfo {
  currency: string
}

export interface TimelineStockPrice extends HistoricalData {
  adjClose: number
  change: number
  changeOverTime: number
  label: string
  unadjustedVolume: number
  vwap: number
}
